













import Vue from "vue";
import PulsingChip from "@/components/PulsingChip.vue";

import { getInstallationStatusIconColor } from "@/utility/Constants";
import { InstallationStatusEnum, installationStatusEnumLabel } from "@/model/data/status/InstallationStatusEnum";
import { InstallationStatus } from "@/model/data/status/InstallationStatus";
import { agentLockCodeTypeEnumLabel } from "@/model/data/agent/LockCodeTypeEnum";

export default Vue.extend({
    components: {
        PulsingChip,
    },
    props: {
        status: Number,
        item: Object as () => InstallationStatus,
        outlined: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        installationStatusEnumLabel,
        getInstallationStatusIconColor,
        agentLockCodeTypeEnumLabel,

        getIconColor(status: InstallationStatusEnum) {
            return getInstallationStatusIconColor(status);
        },
    },
});
